import { lazy } from 'react'

export const AddNewLicenseModalAsync = lazy(() =>
    import('./AddNewLicenseModal').then((component) => ({
        default: component.AddNewLicenseModal,
    }))
)
